import React from "react";

export default function LibraryPeriodSelect({ period, years, onChange, className = "" }) {
  const value = period === "12m" || period == null ? "12m" : String(period);
  return (
    <select
      value={value}
      onChange={(event) => {
        const next = event.target.value;
        onChange?.(next === "12m" ? "12m" : Number(next));
      }}
      className={className}
      aria-label="RFP period"
      data-testid="rfp-library-period"
    >
      <option value="12m">Last 12 months</option>
      {(years || []).map((year) => (
        <option key={year} value={year}>
          {year}
        </option>
      ))}
    </select>
  );
}
